import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { Job } from './job.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { StringFilter, NumberFilter } from 'src/app/filter/filter';

@Resource({
  type: 'paymentmethods',
})
export class PaymentMethods extends AtomResource {
  @Attribute() name?: string;
  @Attribute() method?: string;

  @Relationship() job?: Job;
}

export class PaymentMethodsConfig implements ResourceConfig {
  tables = {
    includes: ['job.firm'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
          },
        ],
        header: 'Name',
        displayed: true,
        sort: 'name',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'method',
        displayedDatas: [
          {
            path: ['method'],
            class: 'mat-body-2',
          },
        ],
        header: 'Method',
        displayed: true,
        sort: 'method',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'job',
        displayedDatas: [
          {
            path: ['job.firm.name'],
            class: 'mat-body-2',
          },
        ],
        header: 'Job Firm',
        displayed: true,
        sort: 'job.firm.name',
        link: {
          resource: 'firms',
          filter: 'job.firm.id',
          icon: 'business',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'network_cell',
      title: [
        {
          path: ['name'],
        },
      ],
      id: true,
    },
    elements: [
      {
        columns: true,
        list: [
          {
            icon: 'arrow_right',
            title: 'Method',
            APIKey: 'method',
            value: {
              path: ['method'],
            },
          },
        ],
      },
      {
        showEmpty: true,
        list: [
          {
            icon: 'business',
            title: 'Job Firm',
            APIKey: 'job',
            value: {
              path: ['job.firm.name'],
            },
            link: {
              resource: 'firms',
              filter: 'job.firm.id',
            },
          },
        ],
      },
    ],
  };
  resource = PaymentMethods;
  resourceName?: string | undefined = 'paymentmethods';
  resourceKey?: string | undefined = 'paymentmethods';
  resourceKeySingle?: string | undefined = 'paymentmethod';
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('method', 'Method'),
    new StringFilter('name', 'Name', true),
    new StringFilter('job.firm.name', 'End User Provider Firm Name'),
    new NumberFilter('job.id', 'End User Provider ID'),
  ];
  includes = ['job.firm'];
}
